<template>
	<section class="gallery-preview">
		<PrimeCard class="settings">
			<template #title>Settings</template>
			<template #content>
				<PrimeIftaLabel>
					<label for="licenseKey">Goodhue License Key</label>
					<PrimeInputText id="licenseKey" v-model="licenseKey" autocomplete="off" />
				</PrimeIftaLabel>
			</template>
		</PrimeCard>
		<PrimeCard class="preview">
			<template #title>Preview</template>
			<template #content>
				<GalleryTable v-if="images.length > 0" class="table" :images />
				<i v-else class="pi pi-spin pi-spinner" style="font-size: 4rem"></i>
			</template>
		</PrimeCard>
	</section>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import { computedAsync } from "@vueuse/core";

import PrimeCard from "primevue/card";
import PrimeInputText from "primevue/inputtext";
import PrimeIftaLabel from "primevue/iftalabel";

import GalleryTable from "@/views/page/GalleryPreview/GalleryTable.vue";

import { supabase } from "@/ts/supabase";

const SESSION_STORAGE_LICENSEKEY = "galleryPreview_licenseKey";
const GALLERY_IMAGES_MIN_LENGTH = 12;

export default defineComponent({
	name: "GalleryPreviewView",
	components: {
		PrimeCard,
		PrimeInputText,
		PrimeIftaLabel,
		GalleryTable
	},

	setup() {
		const licenseKey = ref(sessionStorage.getItem(SESSION_STORAGE_LICENSEKEY) || "");

		const images = computedAsync(async () => {
			const { data: apiImages, error } = await supabase.functions.invoke(
				"get-gallery-images",
				{
					method: "GET",
					headers: {
						"x-goodhue-license-key": licenseKey.value
					}
				}
			);

			if (error) {
				console.error(error);
			}

			if (apiImages && apiImages.length > GALLERY_IMAGES_MIN_LENGTH) {
				sessionStorage.setItem(SESSION_STORAGE_LICENSEKEY, licenseKey.value);
			}

			return apiImages;
		}, []);

		return { licenseKey, images };
	}
});
</script>
<style lang="scss" scoped>
.gallery-preview {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: center;
	gap: 16px;
	max-width: 100%;

	@media only screen and (max-width: 760px) {
		flex-direction: column;

		> * {
			width: 100%;
		}

		.preview {
			:deep(.p-card-body) {
				min-width: 100%;

				.p-card-content {
					.table {
						width: 100% !important;
					}
				}
			}
		}
	}

	.preview {
		:deep(.p-card-body) {
			min-width: 350px;
			min-height: 420px;
			max-height: 80vh;

			.p-card-content {
				overflow-y: scroll;

				.table {
					width: 350px;
				}
			}
		}
	}
}
</style>
